import { takeEvery, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { SHOW_WITHDRAW_MODAL } from '../shared/actions/app';

export default function* saga() {
  if (typeof window === 'undefined') {
    return;
  }

  yield takeEvery(SHOW_WITHDRAW_MODAL, function* () {
    if (window.location.pathname.match(/\/withdraw/)) {
      const base = window.location.pathname.replace(/\/withdraw/g, '');
      yield put(push(base));
      yield new Promise((resolve) => setTimeout(resolve, 0));
      yield put(push(`${base}/withdraw`.replace(/\/{2,}/g, '/')));
      return;
    }
    const pathname = `${window.location.pathname}/withdraw`.replace(/\/{2,}/g, '/');
    yield put(push(pathname));
  });
}
